import { z } from 'zod';

export const ZeeOtherFinancialFormSchema = z.object({
  cash_or_equivalent_assets: z.number().nullable().default(null),
  savings_or_certificates: z.number().nullable().default(null),
  stocks_or_bonds_or_securities: z.number().nullable().default(null),
  retirement_plan_or_ira: z.number().nullable().default(null),
  home_market_value: z.number().nullable().default(null),
  other_real_estate: z.number().nullable().default(null),
  autos: z.number().nullable().default(null),
  other_assets: z.number().nullable().default(null),
  other_assets_description: z.string().nullable().default(null),
  total_assets: z.number().nullable().default(null),

  home_mortgage_balance: z.number().nullable().default(null),
  other_real_estate_debt: z.number().nullable().default(null),
  auto_loans: z.number().nullable().default(null),
  other_debt: z.number().nullable().default(null),
  other_debt_description: z.string().nullable().default(null),
  total_liabilities: z.number().nullable().default(null),

  net_worth: z.string().nullable().default(null),
  home_purchased_years_ago: z.string().nullable().default(null),
  owns_investment: z.string().nullable().default(null),
});
